import { Http } from '../../../support';

const initialState = {
  busy: false,
  resending: false,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.cuenta.configuracion.validation = {
      ...state.cuenta.configuracion.validation,
      ...data,
    };
  });
};

const verify = async (store, params = {}) => {
  store.setState((state) => {
    state.cuenta.configuracion.validation.busy = true;
  });

  try {
    const headers = {
      'X-Tenancy': 'fa/live',
    };

    const response = await Http.get(`/auth/me/verify`, { params, headers });

    store.setState((state) => {
      state.cuenta.configuracion.validation.busy = true;
      state.cuenta.configuracion.validation.data = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.configuracion.validation.busy = true;
      state.cuenta.configuracion.validation.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.cuenta.configuracion.validation = { ...initialState };
  });
};

const EmailValidationStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    verify,
    reset,
  },
};

export default EmailValidationStore;
